import React, { useEffect, useState } from 'react'
import { CButton, CCardBody, CCard } from '@coreui/react'
import { CircleCheck, CircleX, CirclePlus, AlignLeft } from 'lucide-react'
import DiagnosisExaminationView from './DiagnosisExaminationView'
import GeneralExaminationView from './GeneralExaminationView'
import { section } from '../../utils/physicalExaminationData'
import DivLoader from '../../components/shared/DivLoader'
import SaveExtra from '../../services/general/saveExtraData.api'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'
import { diagnosisQuestions } from '../../utils/physicalExaminationData'
import { CModal, CModalFooter, CModalBody, CModalHeader, CModalTitle, CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody } from '@coreui/react'
import HierarchyComponent from './HierarchyComponents'
import CustomAccordionComponent from '../../../src/components/shared/CustomAccordionComponent'
import PESelectedData from './PESelectedData'
import { data } from '../../utils/GESelectedData'
import { GEWithId } from '../../utils/GEWithId'
const PhysicalView = () => {
  const [boxView, setBoxView] = useState('general')
  const [currentView, setCurrentView] = useState('general')
  const [examinationData, setExaminationData] = useState([])
  const [isPageLoading, setIsPageLoading] = useState(true)
  const [showAddEditPopup, setShowAddEditPopup] = useState(false)
  const [generalExaminationData, setGeneralExaminationData] = useState(null)
  const [addPopup, setAddPopup] = useState(false)
  const [editModelVisible, setEditModelVisible] = useState(false)
  const [diagnosisExamination, setDiagnosisExamination] = useState(null)
  const [diagnosisExaminationData, setDiagnosisExaminationData] = useState([])
  const [selectedExamination, setSelectedExamination] = useState(null)
  const [show, setShow] = useState(null)
  const [formattedData, setFormattedData] = useState('')

  const getGeneralExaminationData = async () => {
    //    await SaveExtra('Insert', 'PhysicalExaminationDummyData', JSON.stringify(GEWithId));
    try {
      let data = await SaveExtra('Get_By_Type', 'PhysicalExaminationDummyData', '', '')
      data = JSON.parse(data.d)?.Data || []

      if (data) {
        data = data?.map((item) => {
          return {
            Id: item.Id,
            Data: JSON.parse(item?.JsonData),
          }
        })
      }
      setExaminationData(data)
      setGeneralExaminationData(data[0]?.Data)
      setShow(data[0]?.Data)
    } catch (error) {
      console.log('error', error)
      // toast.error('Failed to fetch data', toastConfig)
    } finally {
      setIsPageLoading(false)
    }
  }

  const getDiagnosisExaminationData = async () => {
    try {
      let data = await SaveExtra('Get_By_Type', 'DiagnosisExaminationDummyData', '', '')
      data = JSON.parse(data.d)?.Data || []

      if (data) {
        data = data?.map((item) => {
          return {
            Id: item.Id,
            Data: JSON.parse(item?.JsonData),
          }
        })
      }

      setDiagnosisExaminationData(data)
      setDiagnosisExamination(data[0]?.Data)
      setShow(data[0]?.Data)
    } catch (error) {
    } finally {
      setIsPageLoading(false)
    }
  }

  useEffect(() => {
    getGeneralExaminationData()
  }, [])

  const handleSubmit = async (updatedData) => {
    try {
      setIsPageLoading(true)
      await SaveExtra('Update', 'PhysicalExaminationDummyData', JSON.stringify(updatedData), examinationData[0]?.Id)
      getGeneralExaminationData()
      toast.success('Saved  Successfully', toastConfig)
    } catch (error) {
      toast.error('Failed to save', toastConfig)
    } finally {
      setIsPageLoading(false)
    }
  }

  const handleDiagnosisSubmit = async (updatedData) => {
    // await SaveExtra('Insert', 'DiagnosisExaminationDummyData', JSON.stringify(diagnosisExamination), '');
    try {
      setIsPageLoading(true)
      await SaveExtra('Update', 'DiagnosisExaminationDummyData', JSON.stringify(updatedData), diagnosisExaminationData[0]?.Id)
      getDiagnosisExaminationData()
      toast.success('Saved  Successfully', toastConfig)
    } catch (error) {
      toast.error('Failed to save', toastConfig)
    } finally {
      setIsPageLoading(false)
    }
  }

  const handleSaveAndClose = (data) => {
    handleSubmit(data)
  }

  const renderView = () => {
    if (currentView === 'diagnosis') {
      return (
        <DiagnosisExaminationView
          diagnosisExamination={diagnosisExamination}
          setDiagnosisExamination={setDiagnosisExamination}
          setShowAddEditPopup={setShowAddEditPopup}
          showAddEditPopup={showAddEditPopup}
          handleSubmit={handleDiagnosisSubmit}
          setAddPopup={setAddPopup}
          handleSaveAndClose={handleSaveAndClose}
          editModelVisible={editModelVisible}
          setEditModelVisible={setEditModelVisible}
          selectedExamination={selectedExamination}
          setSelectedExamination={setSelectedExamination}
        />
      )
    }

    if (currentView === 'general') {
      return (
        <GeneralExaminationView
          generalExaminationData={generalExaminationData}
          setGeneralExaminationData={setGeneralExaminationData}
          setShowAddEditPopup={setShowAddEditPopup}
          showAddEditPopup={showAddEditPopup}
          handleSubmit={handleSubmit}
          setAddPopup={setAddPopup}
          handleSaveAndClose={handleSaveAndClose}
          editModelVisible={editModelVisible}
          setEditModelVisible={setEditModelVisible}
          selectedExamination={selectedExamination}
          setSelectedExamination={setSelectedExamination}
        />
      )
    }
  }

  const [showAllHierarchy, setShowAllHierarchy] = useState(false)
  const [showSelectedData, setShowSelectedData] = useState(false)

  return (
    <div className="position-relative patient-theme-page physical-view-theme">
      <div className="patient-page-wrapper page-wrapper patient-theme-shell dashboard-dark-theme" style={{ minHeight: '100vh', overflow: 'auto' }}>
        <DivLoader isLoading={isPageLoading}>
          <CCard className="m-2 master-grid-theme__toolbar">
            <CCardBody className="w-100 master-grid-theme__toolbar-body p-2">
              <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                <div className="d-flex align-items-center gap-2">
                  <CButton
                    onClick={() => {
                      setAddPopup(true)
                      setShowAddEditPopup(true)
                    }}
                    className={`physical-view-theme__toggle-btn ${addPopup ? 'physical-view-theme__toggle-btn--active' : ''}`}
                  >
                    <CirclePlus size={16} strokeWidth={1.25} />
                    <span className="ms-2">Add</span>
                  </CButton>
                  <CButton
                    onClick={() => {
                      setShowAllHierarchy(!showAllHierarchy)
                    }}
                    className={`physical-view-theme__toggle-btn ${showAllHierarchy ? 'physical-view-theme__toggle-btn--active' : ''}`}
                  >
                    <span>Show</span>
                  </CButton>

                  <CButton
                    onClick={() => {
                      setShowSelectedData(!showSelectedData)
                    }}
                    className={`physical-view-theme__toggle-btn ${showSelectedData ? 'physical-view-theme__toggle-btn--active' : ''}`}
                  >
                    <span>ShowData</span>
                  </CButton>
                </div>
                <div className="d-flex align-items-center justify-content-end gap-2">
                  <CButton
                    onClick={() => {
                      setBoxView('general')
                      setCurrentView('general')
                      getGeneralExaminationData()
                    }}
                    className={`physical-view-theme__toggle-btn ${boxView === 'general' ? 'physical-view-theme__toggle-btn--active' : ''}`}
                  >
                    <AlignLeft size={16} strokeWidth={1.25} />
                    <span className="ms-2">General Physical Examination</span>
                  </CButton>

                  <CButton
                    onClick={() => {
                      setBoxView('diagnosis')
                      setCurrentView('diagnosis')
                      getDiagnosisExaminationData()
                    }}
                    className={`physical-view-theme__toggle-btn ${boxView === 'diagnosis' ? 'physical-view-theme__toggle-btn--active' : ''}`}
                  >
                    <AlignLeft size={16} strokeWidth={1.25} />
                    <span className="ms-2">Diagnosis Examination</span>
                  </CButton>
                </div>
              </div>
            </CCardBody>
          </CCard>

          {renderView()}

          <CModal alignment="center" size="lg" scrollable visible={showAllHierarchy} onClose={() => setShowAllHierarchy(false)} aria-labelledby="VerticallyCenteredExample" className="patient-theme-modal physical-view-theme__modal">
            <CModalHeader onClose={() => setShowAllHierarchy(false)}>
              <CModalTitle id="VerticallyCenteredExample">{boxView == 'general' ? 'General Examination' : 'Diagnosis Examination'}</CModalTitle>
            </CModalHeader>
            <CModalBody>
              <div className="p-3">
                <CAccordion alwaysOpen className="mt-3">
                  {show &&
                    show.map((item, idx) => (
                      <CAccordionItem key={idx} itemKey={idx} className="mt-2 border" style={{ borderRadius: '10px', marginBottom: '10px', overflow: 'hidden' }}>
                        <CAccordionHeader style={{ borderRadius: '10px 10px 0 0' }}>{item.name}</CAccordionHeader>
                        <CAccordionBody style={{ borderRadius: '0 0 10px 10px', padding: '15px' }}>
                          <HierarchyComponent viewData={item} />
                        </CAccordionBody>
                      </CAccordionItem>
                    ))}
                </CAccordion>
              </div>
            </CModalBody>

            <CModalFooter>
              <CButton color="secondary" className="ui-action-btn ui-action-btn--secondary" onClick={() => setShowAllHierarchy(false)}>
                Close
              </CButton>
            </CModalFooter>
          </CModal>

          <CModal
            size="xl"
            scrollable
            visible={showSelectedData}
            onClose={() => setShowSelectedData(false)}
            aria-labelledby="VerticallyCenteredExample"
            className="patient-theme-modal physical-view-theme__modal"
          >
            <CModalHeader onClose={() => setShowSelectedData(false)}>
              <CModalTitle id="VerticallyCenteredExample">{boxView == 'general' ? 'General Examination' : 'Diagnosis Examination'}</CModalTitle>
            </CModalHeader>
            <CModalBody>
              <div className="p-3">
                <PESelectedData physicalExaminationData={data} onFormattedDataRead={setFormattedData} />
              </div>
            </CModalBody>

            <CModalFooter>
              <CButton color="secondary" className="ui-action-btn ui-action-btn--secondary" onClick={() => setShowSelectedData(false)}>
                Close
              </CButton>
            </CModalFooter>
          </CModal>
        </DivLoader>
      </div>
    </div>
  )
}

export default PhysicalView
